import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Soulful Customs. All rights reserved.</p>
    </footer>
  );
}